module.exports = __webpack_public_path__ + "media/images/pills-1199a88aa42c7358c25efbfc7a72110b.png";